module.exports = __webpack_public_path__ + "static/media/EFS-HD-LOGO.daef57e7.svg";